import { render, staticRenderFns } from "./RequestsControl.vue?vue&type=template&id=1ee4775a&scoped=true&"
import script from "./RequestsControl.vue?vue&type=script&lang=js&"
export * from "./RequestsControl.vue?vue&type=script&lang=js&"
import style0 from "./RequestsControl.vue?vue&type=style&index=0&id=1ee4775a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee4775a",
  null
  
)

export default component.exports